import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Documents from "./pages/Documents";
import DocumentEditor from "./pages/DocumentEditor";
import Catalog from "./pages/Catalog";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Subcontracting from "./pages/Subcontracting";
import Etudes from "./pages/Etudes";
import EtudeEditor from "./pages/EtudeEditor";
import Calculator from "./pages/Calculator";
import Nesting from "./pages/Nesting";
import Boutique from "./pages/Boutique";
import Reseau from "./pages/Reseau";
import Gabarits from "./pages/Gabarits";
import PaymentReturn from "./pages/PaymentReturn";
import Legal from "./pages/Legal";
import SitePages from "./pages/SitePages";
import SitePageEditor from "./pages/SitePageEditor";
import PublicPage from "./pages/PublicPage";
import Experts from "./pages/Experts";
import Expenses from "./pages/Expenses";
import Realisations from "./pages/Realisations";
import Settings from "./pages/Settings";
import AgendaExpert from "./pages/AgendaExpert";
import Reviews from "./pages/Reviews";
import PublicDirectory from "./pages/PublicDirectory";
import PublicArtisan from "./pages/PublicArtisan";
import ReviewSubmit from "./pages/ReviewSubmit";
import NetworkMap from "./pages/NetworkMap";
import CityDirectory from "./pages/CityDirectory";
import WidgetReviews from "./pages/WidgetReviews";
import NetworkAdmin from "./pages/NetworkAdmin";
import Placeholder from "./pages/Placeholder";
import Clients from "./pages/Clients";
import Atelier from "./pages/Atelier";
import Materials from "./pages/Materials";
import Statistics from "./pages/Statistics";
import Templates from "./pages/Templates";
import Prospects from "./pages/Prospects";
import PortalLogin from "./pages/portal/PortalLogin";
import PortalDashboard from "./pages/portal/PortalDashboard";
import PortalProject from "./pages/portal/PortalProject";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-sky-300">
        Chargement…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/site/:companyId/page/:slug" element={<PublicPage />} />
            <Route path="/annuaire" element={<PublicDirectory />} />
            <Route path="/annuaire/:companyId" element={<PublicArtisan />} />
            <Route path="/selliers/:city" element={<CityDirectory />} />
            <Route path="/avis/:token" element={<ReviewSubmit />} />
            <Route path="/reseau-carte" element={<NetworkMap />} />
            <Route path="/widget/avis/:companyId" element={<WidgetReviews />} />
            <Route path="/portail" element={<PortalLogin />} />
            <Route path="/portail/projets" element={<PortalDashboard />} />
            <Route path="/portail/projets/:id" element={<PortalProject />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/prospects" element={<Prospects />} />
              <Route path="/atelier" element={<Atelier />} />
              <Route path="/matieres" element={<Materials />} />
              <Route path="/modeles" element={<Templates />} />
              <Route path="/statistiques" element={<Statistics />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/documents/:id" element={<DocumentEditor />} />
              <Route path="/documents/new/:type" element={<DocumentEditor />} />
              <Route path="/catalogue" element={<Catalog />} />
              <Route path="/projets" element={<Projects />} />
              <Route path="/projets/:id" element={<ProjectDetail />} />
              <Route path="/sous-traitance" element={<Subcontracting />} />
              <Route path="/etudes" element={<Etudes />} />
              <Route path="/etudes/:id" element={<EtudeEditor />} />
              <Route path="/calculateur" element={<Calculator />} />
              <Route path="/imposition" element={<Nesting />} />
              <Route path="/gabarits" element={<Gabarits />} />
              <Route path="/boutique" element={<Boutique />} />
              <Route path="/reseau" element={<Reseau />} />
              <Route path="/experts" element={<Experts />} />
              <Route path="/avis-clients" element={<Reviews />} />
              <Route path="/reseau-admin" element={<NetworkAdmin />} />
              <Route path="/depenses" element={<Expenses />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/parametres" element={<Settings />} />
              <Route path="/agenda-expert" element={<AgendaExpert />} />
              <Route path="/pages" element={<SitePages />} />
              <Route path="/pages/new" element={<SitePageEditor />} />
              <Route path="/pages/:id" element={<SitePageEditor />} />
              <Route path="/payment/success" element={<PaymentReturn />} />
              <Route path="/payment/cancel" element={<PaymentReturn />} />
              <Route path="/mentions-legales" element={<Legal type="mentions" />} />
              <Route path="/cgv" element={<Legal type="cgv" />} />
              <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
              <Route path="/accessibilite" element={<Legal type="accessibilite" />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
